module.exports = __webpack_public_path__ + "static/artist-c3ebdf7320b168210cc46cf0cafe218d.png";